import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hint": "pbui-wjr7W",
  "hint--no-error": "pbui-lt3uO",
  "hint--has-error": "pbui-88EqZ",
  "label": "pbui-4De3l",
  "container": "pbui-BqVmN",
  "textarea": "pbui-hvsjH",
  "textarea--no-error": "pbui-gVsR6",
  "textarea--has-error": "pbui-HE-TB",
  "nothing": "pbui-GF25q",
  "textarea--focus-orange": "pbui-nZ4NU"
};
export var Label = function Label(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _jsx("label", _extends({
      className: styles.label
    }, rest, {
      children: children
    }))
  );
};